import validate from "/app/node_modules/.pnpm/nuxt@3.13.0_patch_hash=vqjrgo3cjrje5mjjjciwfs2hgq_@parcel+watcher@2.5.0_@types+node@20.10.1_d_gxvhhwhqa32jek4a5scifwt2t4/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45redirect_45global from "/app/middleware/01.redirect.global.ts";
import _02_45auth_45global from "/app/middleware/02.auth.global.ts";
import _03_45store_45global from "/app/middleware/03.store.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.13.0_patch_hash=vqjrgo3cjrje5mjjjciwfs2hgq_@parcel+watcher@2.5.0_@types+node@20.10.1_d_gxvhhwhqa32jek4a5scifwt2t4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45redirect_45global,
  _02_45auth_45global,
  _03_45store_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}